import { useOptionalSidePanelPresentation } from 'designSystem/components/sidePanelContext'
import { EvidenceChip } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip'
import type { CmmsRecordCitation } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/documentSearchApiSchemas'
import { useSearchActions } from 'features/knowledgeDocumentViewer/contexts/SearchActionsContext'
import { citedQuotesFragment } from 'features/knowledgeDocumentViewer/utils/citedQuotesFragment'
import { workOrderDocumentRow } from 'features/knowledgeDocumentViewer/workOrders/workOrder'

import type { PreviewDocumentHandler } from './previewDocumentHandler'

export function ResponseSegmentCmmsChip({
  citation,
  onPreviewDocument,
  onCitationHoverChange,
}: {
  citation: CmmsRecordCitation
  onPreviewDocument?: PreviewDocumentHandler
  onCitationHoverChange?: (open: boolean) => void
}) {
  const { onOpenNewTab } = useSearchActions()
  const sidePanel = useOptionalSidePanelPresentation()
  const quotes = citation.failure_reason ? [] : [citation.quote]
  const openInNewTab = () =>
    onOpenNewTab({
      documentId: citation.entry_id,
      pageNumber: 1,
      fragmentHighlight: citedQuotesFragment(1, quotes, citation.version),
    })
  const openPreview = () => {
    if (!onPreviewDocument) {
      openInNewTab()
      return
    }
    sidePanel?.keepOpenOnNextOutsideClick()
    onPreviewDocument(workOrderDocumentRow(citation), 1, quotes)
  }
  return (
    <EvidenceChip
      documentId={citation.entry_id}
      title={citation.number}
      filename={`${citation.number}.pdf`}
      pageNum={1}
      showPageNumber={false}
      quotes={[citation.quote]}
      failureReason={citation.failure_reason ? 'quote_not_in_page_text' : null}
      onClick={openPreview}
      onOpenInNewTab={openInNewTab}
      onOpenChange={onCitationHoverChange}
    />
  )
}
